import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, updateUserState } from '@/api/system/user/user';
import waves from '@/directive/waves'; // 水波纹指令

import userAdd from './add';
import userPassword from './password';
export default {
  name: 'ComplexTable',
  components: {
    userAdd: userAdd,
    userPassword: userPassword
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        userAcc: '',
        userName: '',
        mobilephone: ''
      },
      title: '',
      userId: null,
      userMode: {},
      multipleSelection: [],
      dialogFormVisible: false,
      PassFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    isHideButton: function isHideButton(isSuper) {
      if (isSuper === null) {
        return false;
      } else {
        if (isSuper === 1) {
          return false;
        } else {
          return true;
        }
      }
    },
    // handleRowClass({ row, rowIndex }) {
    //   if (rowIndex % 2 === 0) {
    //     return ''
    //   } else {
    //     return ''
    //   }
    // },
    handleEditPwd: function handleEditPwd(row) {
      this.userMode = row;
      this.userId = row.userId;
      this.PassFormVisible = true;
    },
    handCanclePwd: function handCanclePwd() {
      this.getList();
      this.PassFormVisible = false;
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.userId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(userId) {
      this.userId = userId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(userIds) {
      var _this2 = this;

      if (userIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(userIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleUserState: function handleUserState(userId, state) {
      var _this3 = this;

      this.$confirm('你确定是要' + (state === 0 ? '启用' : '禁用') + '这个用户, 是否继续?', '提示').then(function () {
        updateUserState(userId, state).then(function (response) {
          _this3.getList();

          _this3.Alert({
            alertType: 'add',
            message: '操作成功'
          });
        });
      });
    },
    handleDelete: function handleDelete(userId) {
      var userIds = [];
      userIds.push(userId);
      this.delete(userIds);
    },
    handleDeletes: function handleDeletes() {
      var userIds = [];
      this.multipleSelection.forEach(function (row) {
        userIds.push(row.userId);
      });
      this.delete(userIds);
    }
  }
};